
import { Component, Vue } from 'vue-property-decorator'
import ConfigOptionService from '@/biz/service/System/ConfigOptionService'

@Component
export default class ViewSystemConfigIndex extends Vue {
  private Service = ConfigOptionService
}
